import { Badge as RadixBadge } from '@radix-ui/themes'
import { forwardRef } from 'react'
import type { ComponentPropsWithoutRef } from 'react'

type BadgeProps = ComponentPropsWithoutRef<typeof RadixBadge>

export const Badge = forwardRef<HTMLSpanElement, BadgeProps>(
  ({ className = '', ...props }, ref) => {
    return <RadixBadge className={className} ref={ref} {...props} />
  }
)

Badge.displayName = 'Badge'
